"use strict";

import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import React from "react";
import { observer } from "mobx-react";
import classNames from "classnames";
import { action, observable } from "mobx";
import Panel from "../../Panel/Panel";
import OnClickOutside from "../../../../utils/OnClickOutside";
import { randomString } from "../../../../utils";
import { ChevronDown } from "../../../icons";
import { DropdownContext } from "./DropdownContext";
import { DropdownTheme } from "./DropdownTheme";
export var DropdownSize = /* @__PURE__ */function (DropdownSize2) {
  DropdownSize2["Small"] = "small";
  DropdownSize2["Medium"] = "medium";
  DropdownSize2["Large"] = "large";
  return DropdownSize2;
}(DropdownSize || {});
var TabKey = "Tab";
var Dropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(Dropdown, _React$Component);
  var _super = _createSuper(Dropdown);
  function Dropdown(props) {
    var _this;
    _classCallCheck(this, Dropdown);
    _this = _super.call(this, props);
    _this.showingMenu = false;
    _this.onKeyUp = function (event) {
      if (event.key == TabKey && !_this.showingMenu) {
        _this.showDropdown();
      }
    };
    _this.onKeyDown = function (event) {
      if (event.key == TabKey) {
        _this.hideDropdown();
      }
    };
    _this.toggleDropdown = function () {
      if (_this.showingMenu) {
        _this.hideDropdown();
      } else {
        _this.showDropdown();
      }
    };
    _this.showDropdown = function () {
      _this.showingMenu = true;
      _this.onClickOutside.startListening();
    };
    _this.hideDropdown = function () {
      _this.showingMenu = false;
      _this.onClickOutside.stopListening();
    };
    _this.hideDropdownFromOutside = function () {
      _this.onClickOutside.stopListening();
      setTimeout(function () {
        _this.showingMenu = false;
      }, 0);
    };
    _this.identifier = "dropdown".concat(randomString());
    var clickSelectors = ["#".concat(_this.identifier, " .dropdown__button")];
    if (props.remainOpenOnSelect) {
      clickSelectors.push("#".concat(_this.identifier, " .dropdown-item"));
    }
    _this.onClickOutside = new OnClickOutside(clickSelectors, _this.hideDropdownFromOutside);
    return _this;
  }
  _createClass(Dropdown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        label = _this$props.label,
        size = _this$props.size,
        children = _this$props.children,
        _this$props$theme = _this$props.theme,
        theme = _this$props$theme === void 0 ? DropdownTheme.Light : _this$props$theme;
      return /* @__PURE__ */React.createElement("div", {
        className: classNames("dropdown", _defineProperty({}, "dropdown--dark", theme === DropdownTheme.Dark)),
        id: this.identifier
      }, label && /* @__PURE__ */React.createElement("div", {
        className: classNames("dropdown__label", {
          "dropdown__label--long": this.props.hasLongLabel
        })
      }, label), /* @__PURE__ */React.createElement("div", {
        className: classNames(["dropdown__button", "center-aligned", {
          "dropdown__button--toggled": this.showingMenu
        }, "dropdown__button--".concat(size)]),
        onClick: this.toggleDropdown,
        onKeyUp: this.onKeyUp,
        onKeyDown: this.onKeyDown,
        tabIndex: 0
      }, this.renderNameOrPlaceholder(), /* @__PURE__ */React.createElement(ChevronDown, {
        className: "dropdown__arrow"
      })), this.showingMenu && /* @__PURE__ */React.createElement(Panel, {
        className: "dropdown__menu fade-in-down",
        theme: theme === DropdownTheme.Light ? "light" : "dark"
      }, /* @__PURE__ */React.createElement(DropdownContext.Provider, {
        value: {
          theme: theme
        }
      }, children)));
    }
  }, {
    key: "renderNameOrPlaceholder",
    value: function renderNameOrPlaceholder() {
      var _this$props2 = this.props,
        name = _this$props2.name,
        placeholder = _this$props2.placeholder,
        size = _this$props2.size;
      var hasName = !!name;
      return /* @__PURE__ */React.createElement("span", {
        className: classNames(["dropdown__name", "dropdown__name--".concat(size), {
          "dropdown__name--placeholder": !hasName
        }])
      }, hasName ? name : placeholder);
    }
  }]);
  return Dropdown;
}(React.Component);
Dropdown.defaultProps = {
  placeholder: "",
  disabled: false,
  size: "small" /* Small */,
  remainOpenOnSelect: false
};
__decorateClass([observable.ref], Dropdown.prototype, "showingMenu", 2);
__decorateClass([action], Dropdown.prototype, "toggleDropdown", 2);
__decorateClass([action], Dropdown.prototype, "showDropdown", 2);
__decorateClass([action], Dropdown.prototype, "hideDropdown", 2);
__decorateClass([action], Dropdown.prototype, "hideDropdownFromOutside", 2);
Dropdown = __decorateClass([observer], Dropdown);
export { Dropdown as default };